import 'vant/es/dialog/style';
import 'vant/es/toast/style';
import 'vant/es/image-preview/style';

import {
  closeToast,
  setToastDefaultOptions,
  showConfirmDialog,
  showDialog,
  showFailToast,
  showImagePreview,
  showLoadingToast,
  showSuccessToast,
} from 'vant';

import type { DialogInterface, ToastInterface } from './types.d.ts';

setToastDefaultOptions({
  forbidClick: true,
  overlay: true,
  duration: 3000,
});

setToastDefaultOptions('loading', {
  duration: 0,
});

export const Dialog: DialogInterface = {
  confirm(options) {
    return showConfirmDialog(options);
  },
  alert(options) {
    return showDialog(options);
  },
  image(...options) {
    showImagePreview(...options);
  },
};

export const Toast: ToastInterface = {
  loading(message) {
    showLoadingToast(message);
  },
  okay(message) {
    showSuccessToast(message);
  },
  fail(message) {
    showFailToast(message);
  },
  close() {
    closeToast();
  },
};
